export default __webpack_public_path__ + "static/media/Jesus.c86acfa3.png";